// Pure check that the WHT / GST-withheld recognised on a receipt do not exceed
// what the approved invoice allows. No Firestore.
//
// The allowed amounts are the ones frozen on the approved snapshot (totals.whtAmount
// and totals.gstWithheldAmount), minus whatever earlier receipts already
// recognised — so an invoice at 18% GST is judged on its own GST, not a profile
// default. Anything above that (beyond a few rupees of rounding) must be
// explained with a written reason, which is stored on the allocation.
import { round } from "./whtCalculator";

export const DEDUCTION_TOLERANCE = 5;

const fmt = (value) => `PKR ${round(value).toLocaleString("en-PK")}`;

// -> { whtRemaining, gstRemaining, whtOver, gstOver, exceeds }
export function deductionStatus({ expectedWht, expectedGst, priorWht = 0, priorGst = 0, wht = 0, gst = 0, tolerance = DEDUCTION_TOLERANCE }) {
  const whtRemaining = Math.max(0, round(Number(expectedWht || 0) - Number(priorWht || 0)));
  const gstRemaining = Math.max(0, round(Number(expectedGst || 0) - Number(priorGst || 0)));
  const whtOver = Math.max(0, round(Number(wht || 0) - whtRemaining));
  const gstOver = Math.max(0, round(Number(gst || 0) - gstRemaining));
  return {
    whtRemaining, gstRemaining,
    whtOver: whtOver > tolerance ? whtOver : 0,
    gstOver: gstOver > tolerance ? gstOver : 0,
    get exceeds() { return this.whtOver > 0 || this.gstOver > 0; }
  };
}

// Returns "" when the deductions are allowed, otherwise the reason they are not.
export function deductionProblem({ invoiceNumber, overrideReason, ...figures }) {
  const status = deductionStatus(figures);
  if (!status.exceeds) return "";
  if (String(overrideReason || "").trim()) return "";
  const parts = [];
  if (status.whtOver) parts.push(`WHT ${fmt(figures.wht)} is ${fmt(status.whtOver)} more than the ${fmt(status.whtRemaining)} still allowed`);
  if (status.gstOver) parts.push(`GST withheld ${fmt(figures.gst)} is ${fmt(status.gstOver)} more than the ${fmt(status.gstRemaining)} still allowed`);
  return `${invoiceNumber}: ${parts.join("; ")} by the approved invoice. Correct the amount, or enter a reason for the difference (for example the client withheld at a different rate) so it is documented.`;
}
